import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useAllowedActions} from '../../../hooks/useAllowedActions.ts';
import {SimulateButton} from '../buttons/SimulateButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {Registration} from '../types';

interface IndexPageHeaderProps {
    selectedRecords: Registration[];
    setSelectedRecords: (records: Registration[]) => void;
}

const useTools = (selectedRecords: Registration[], setSelectedRecords: (records: Registration[]) => void) => {

    const {allowedActions} = useAllowedActions();

    const tools = [];

    if (allowedActions.includes('SimulateRegistration')) {
        tools.push(<SimulateButton key='simulate'/>);
    }

    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes('DeleteRegistration')) {
        tools.push(<DeleteRecordButton key='delete' selectedRecords={selectedRecords}
                                       setSelectedRecords={setSelectedRecords}/>);
    }

    if (allowedActions.includes('CreateRegistration')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = ({selectedRecords, setSelectedRecords}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Registrations')}
            tools={useTools(selectedRecords, setSelectedRecords)}
        />
    );
};
